import checkMark from 'images/icons/check-black.svg';
import pokerstarsRadioSvg from 'images/icons/pokerstars-checked-radio-icon.svg';
import breakpoints from 'style-utils/breakpoints';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
 :root {
   /* FOR JUMIO ALLOWED VARIABLES SEE : https://docs.web.jumio.ai/?path=/docs/websdk-jumio-sdk--documentation#setting-the-primary-color-palette  */
    --jumio-sdk-font: "Roboto", sans-serif;
    --jumio-sdk-color-primary1: #BFBFBF;
    --jumio-sdk-color-primary2: #02bd9c;
    --jumio-sdk-color-primary3: #02bd9c;
    --jumio-sdk-color-primary5: #02bd9c;

    /* ---COLORS--- */

    /* generics */
    --background: hsl(0, 0%, 100%);
    --primary-text: hsl(0 0% 13.33%);
    --paper: hsl(0 0% 100%);

    /* cta */
    --component-button-color-primary-bg-default: #02bd9c;
    --component-button-color-primary-border-default: #02bd9c;
    --component-button-size-border-radius: 100px;
    --component-button-size-border-width: 1px;
    --component-button-color-primary-border-hover: #55D3BD;
    --component-button-color-primary-bg-hover: #06D6AE;
    --component-button-color-primary-border-pressed: #089b80;
    --component-button-color-primary-bg-pressed: #089b80;
    --component-button-color-primary-border-disabled: #DEDEDE;
    --component-button-color-primary-bg-disabled: #B1E3D8;

    --component-button-color-secondary-border-default: #000;
    --component-button-color-secondary-bg-default: #fff;
    --component-button-color-secondary-border-hover: #000;
    --component-button-color-secondary-bg-hover: #dedede;
    --component-button-color-secondary-border-pressed: #000;
    --component-button-color-secondary-bg-pressed: #bfbfbf;

    --btn-primary-text: #222222;
    --btn-outlined-text: var(--btn-primary-text);
    

    /* navbar */
    --site-header-bg: hsla(0, 0%, 0%, 1);
    --site-header-text: white;
    --site-header-toolbar: hsla(0, 0%, 0%, 1);
    --site-header-tab-link-hover: white;
    --sidebar-link-text: #222222;
    --sidebar-link-selected-text: #222222;
    --sidebar-link-selected-icon: #D70022;
    --sidebar-link-selected-bg: #F5F5F5;
    --site-section-bg: #1C1C1C;
    --site-section-text:white;
    --transaction-site-header-border-color:black;

      /* slidein menu */
    --slidein-header-tab-link-hover-desktop: #fff;
    --slidein-header-tab-link-hover: #fff;
    --expanded-menu-color:#fff;
    --border-color-tab-link-hover: #D70A0A;
    --slidein-menu-promo-btn-bg: #E50B78;
    --slidein-menu-btn-bg: #02bd9c;

    /* dialog */
    --overlay: 0deg 0% 13.33%;
    --dialog-paper: hsl(0 0% 100%);
    --dialog-header: #000000;
    --dialog-header-text: rgb(255, 255, 255);
    --dialog-footer-border: #d3d3d3;
    --dialog-footer-border-md: #d3d3d3;
    --dialog-footer-background: var(--dialog-paper);

    /* form */
    --field-background: hsl(0 0% 100%);
    --field-popover: hsl(0deg 0% 94.9%);
    --field-border: #BFBFBF;
    --field-border-focus: hsla(0, 0%, 13%, 1);
    --field-ring-focus: transparent;
    --field-warning: hsl(0deg 100% 55.1%);
    --field-error: hsl(0deg 100% 55.1%);
    --field-error-background: hsla(351, 54%, 97%, 1);
    --field-positive-feedback: hsla(147, 84%, 27%, 1);
    --field-text: #000000;
    --field-label: hsla(0, 0%, 56%, 1);
    --field-label-floating: hsla(0, 0%, 13%, 1);
    --field-checked-radio: #02bb9c;
    --field-radio-checked-bg: #e6f9f9;
    --field-checked-checkbox: url(${checkMark});
    --field-radio-checked-background: url(${pokerstarsRadioSvg});
    --field-border-width:1px;

    /* alert bar */
    --alert-bar-info-bg: #e1eefe;
    --alert-bar-info-shadow-inset: rgb(103, 170, 249) 0px -2px 0px inset;
    --alert-bar-caution-bg: #FFF7E8;
    --alert-bar-caution-shadow-inset: rgba(255, 142, 13, 0.5) 0px -2px 0px inset;
    --alert-bar-success-bg: #F2FAD7;
    --alert-bar-success-shadow-inset: rgba(190, 214, 47, 0.5) 0px -2px 0px inset;
    --alert-bar-caution-transaction-bg: #FFF7E8;
    --alert-bar-caution-transaction-shadow-inset: rgba(255, 142, 13, 0.5) 0px -2px 0px inset;
    --alert-bar-error-bg: #FBD2D3;
    --alert-bar-error-shadow-inset: #EB1E23 0px -2px 0px inset;;


    /* banners */
    --error-banner: hsl(359, 84%, 90%);
    --error-banner-border: hsla(359, 84%, 52%, 1);
    --card-border: #bfbfbf;
    --translucent-banner-bg:#008916;
    --translucent-banner-success-color:white;
    --translucent-banner-error-color: white;
    --translucent-banner-error-bg: #eb1e23;
    --betting-banner-height: 88px;
    --betting-banner-height-md: 75px;

    /* stepper */
    --stepper-idle: hsla(0, 0%, 83%, 1);
    --stepper-active: #02bb9c;
    --stepper-active-border: #000000;
    --stepper-group-fill: #e6f9f9;

    /* note */
    --note: hsla(45, 100%, 50%, 1);

    /* loader */
    --loader: rgba(255, 255, 255, 0.95);

    /* links */
    --recaptcha-link: hsla(0, 0%, 13%, 1);

    /* icons */

    --footer-icon: #00c7c7;
    --success-icon-width: 50px;

    --ribbon-1: #8b45c1;
    --ribbon-2: #2e094a;
    --gender-radio-checked: #e6f9f9;
    --gender-radio-checked-border: #00c7c7;
    --thankyou-banner-bg: #f1e8f7;
    --thankyou-banner-border: #8b45c1;

    --success-circle: #008916;
    --success-circle-mark: white;
    --error-circle: #c40909;
    --error-circle-mark: white;

    /* toast message */
    --component-toast-surface-error: #1A252E;
    --component-toast-border-error: #D3D3D3;

    /* COMPONENTS */

    /* profile - status pill */

    --verified-pill: #0A7D41;
    --verified-pill-text: white;
    --not-verified-pill: #FABB00;
    --not-verified-pill-text: black;

    /* recharge */

    --selected-payment-card-border: #02BD9C;
    --selected-payment-card-background: #e6f8f5;
    --title-font-weight: 500; 
    --recharge-review-background: none;
    --recharge-review-background-sm: none;
    --recharge-review-title-margin: 0 0 14px 0;
    --recharge-review-stornoAnnullo: 14px;

    @media (max-width: ${breakpoints.md}px) {
      --recharge-review-title-margin: 14px 0;
    }

    /* pagination */
    --pagination-item: #02bd9c;
    --pagination-item-text: black;

    /* tablist */
    --selected-tab: #D70A0A;

    /* tablist bonus */
    --component-navigation-tab-nav-chip-copy-default: #000;
    --component-navigation-tab-nav-chip-layout-radius-default: 100px;
    --component-navigation-tab-nav-chip-surface-default: #FFF;
    --component-navigation-tab-nav-chip-surface-active: #02BD9C;

    /* fun bonus */
     --loader-background-color: #DEDEDE;
     --loader-background-fill: #02BD9C;
     --bonus-progress-font-size: 10px;
     --bonus-progress-line-height: 12px; 
     --responsible-game-loader-bg-fill: linear-gradient(90deg, #4EB99A 0%, #797FCA 100%);

    /* self exclusion */
    --option-border-radius: 4px;
    --option-border-color: #016856;
    --option-bg-color: #02BD9C;
    --option-border-color-selected: #02BD9C;

    --checkBox-excluded-bg: #575757;
    --checkbox-excluded-icon: url(${checkMark});

    --checkbox-rounded-active-border-color: #02bd9c;
    --checkbox-rounded-active-bg-color: #02bd9c;

    /* promo code recharge */

    --active-promo-card-bg:#E6F8F5;
    --active-promo-card-border:#02BD9C;
    --inactive-promo-card-bg:#EFF2F5;

    /* active limit widget */
    --active-limit-box-border-radius: 8px;
    --active-limit-background: #E6F9F9;

    /* spendability list */
    --spendability-value-col-font-weight: 700; 
    --spendability-value-col-font-size: 14px;

    /* ---BORDER-RADIUS--- */

    /* cta */
    --btn-radius: 62.5px;

    /* dialog */
    --dialog-radius: 6.25px;

    /* field */
    --field-radius: 2.5px;

    /* ---BORDER-WIDTH--- */

    /* cta */
    --btn-border-width: .625px;

    /* PADDING */

    /* dialog */
    --dialog-header-py: 12.5px;

    /* WIDTH */

    --dialog-max-w: 373.75px;

    /* HEIGHT */

    --header-height: 25px;
    --header-height-md: 31.25px;

    /* SHADOW */

    --radio-cta-shadow: 0px 0px 0px 1px hsla(0, 0%, 0%, 1);
    --paper-shadow: 0px 0px 0px 1px #bfbfbf;

    /* FONT FAMILY */
    --primary-font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    --secondary-font-family: var(--primary-font-family);
    

    --message-label-radius:4px;


    /* PAGES */

    /* PROFILE - DOCUMENT STATUS */
    --document-pending: #0C78D1;

    --min-width-modify-cta: 170px;
    --min-width-verify-cta: 170px;    
    @media (max-width: 399px) {
      --min-width-modify-cta: 120px;
      --min-width-verify-cta: 120px;    
      }
  }

  #root {
    height: 100vh;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  .no-scrollbar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

`;
